/**
 * Fases da linha de cuidado e agravos acompanhados.
 * As fases espelham o enum `fase_linha_cuidado_enum` do banco.
 */
export const FASES = [
  'pre_natal',
  'maternidade',
  'neonatologia',
  'puericultura',
  'acompanhamento',
] as const;

export type Fase = (typeof FASES)[number];

export const ROTULO_FASES: Record<Fase, string> = {
  pre_natal: 'Pré-natal',
  maternidade: 'Maternidade',
  neonatologia: 'Neonatologia',
  puericultura: 'Puericultura',
  acompanhamento: 'Acompanhamento',
};

export const AGRAVOS = ['sifilis', 'hiv', 'hbv', 'hcv', 'chagas'] as const;

export type Agravo = (typeof AGRAVOS)[number];

export interface DescricaoAgravo {
  rotulo: string;
  /**
   * D-014: hepatites e Chagas aparecem no sistema, mas ficam bloqueados com o
   * selo "Em desenvolvimento". No Módulo 1+ este valor virá dos parâmetros do
   * sistema (controlado pelo superadmin); aqui é o padrão inicial.
   */
  disponivel: boolean;
}

export const DESCRICAO_AGRAVOS: Record<Agravo, DescricaoAgravo> = {
  sifilis: { rotulo: 'Sífilis', disponivel: true },
  hiv: { rotulo: 'HIV', disponivel: true },
  hbv: { rotulo: 'Hepatite B', disponivel: false },
  hcv: { rotulo: 'Hepatite C', disponivel: false },
  chagas: { rotulo: 'Doença de Chagas', disponivel: false },
};

export const MENSAGEM_EM_DESENVOLVIMENTO =
  'Este módulo está em desenvolvimento e estará disponível em breve.';
